import { render, staticRenderFns } from "./releaseNotesButton.vue?vue&type=template&id=7b03a1b8&"
import script from "./releaseNotesButton.vue?vue&type=script&lang=js&"
export * from "./releaseNotesButton.vue?vue&type=script&lang=js&"
import style0 from "./releaseNotesButton.vue?vue&type=style&index=0&id=7b03a1b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports